import React, { useState } from "react";
import countryList from "react-select-country-list";
import "flag-icons/css/flag-icons.min.css"; // Import flag icons
import CustomReactSelect from "../../../../general/form/CustomReactSelect";

const CountrySelect = ({ onChange, isDisabled }) => {
  const [options] = useState(
    countryList().getData().map((country) => ({
      ...country,
      flagCode: country.value.toLowerCase(), // Convert country code to lowercase for flag-icons
    }))
  );

  return (
    <CustomReactSelect
      options={options}
      onChange={onChange}
      isDisabled={isDisabled}
      isMulti
      placeholder="Select countries"
      formatOptionLabel={(country) => (
        <div style={{ display: "flex", alignItems: "center" }}>
          <span
            className={`fi fi-${country.flagCode}`}
            style={{ marginRight: "8px", }}
          ></span>
          {country.label}
        </div>
      )}
      isSearchable
    />
  );
};

export default CountrySelect;
